document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('.prod-features-card');

  cards.forEach(card => {
    const inner = card.querySelector('.prod-features-card-inner');

    // Create 3D Flip Timeline targeting the inner container
    const tl = gsap.timeline({ paused: true });

    tl.to(inner, {
      rotateY: 180,
      duration: 0.65,
      ease: 'power2.inOut'
    });

    card.gsapTimeline = tl;

    // Desktop Hover Bindings
    card.addEventListener('mouseenter', () => {
      if (window.innerWidth > 749) {
        card.style.borderColor = '#e6a15c';
        tl.play();
      }
    });

    card.addEventListener('mouseleave', () => {
      if (window.innerWidth > 749) {
        card.style.borderColor = '#1c1c1c';
        tl.reverse();
      }
    });

    // Mobile Click/Tap Handlers
    card.addEventListener('click', function (e) {
      if (window.innerWidth <= 749) {
        const isCloseBtn = e.target.closest('.back-card-return-trigger');
        const isActive = this.classList.contains('is-mobile-active');

        if (isCloseBtn || isActive) {
          // Flip back to front
          this.classList.remove('is-mobile-active');
          this.style.borderColor = '#1c1c1c';
          tl.reverse();
          e.stopPropagation();
        } else {
          // Reset other open cards first, then flip this one
          cards.forEach(c => {
            c.classList.remove('is-mobile-active');
            c.style.borderColor = '#1c1c1c';
            if (c.gsapTimeline) c.gsapTimeline.reverse();
          });

          this.classList.add('is-mobile-active');
          this.style.borderColor = '#e6a15c';
          tl.play();
        }
      }
    });
  });
});